export default {
  title: 'Wprowadź kwotę zwrotu',
  description: 'Dostępne do zwrotu: {{amount}}',
  form: {
    amount: {
      label: 'Zwrot',
    },
    reason: {
      label: 'Powód',
      options: {
        requested_by_customer: 'na żądanie klienta',
        reclamation: 'reklamacja',
        communication_error: 'błąd komunikacji',
        other: 'inne',
      },
    },
    manual_reason: {
      label: 'Wprowadź powód zwrotu',
    },
  },
  feedback: {
    amount_too_small: 'Minimalna kwota zwrotu {{amount}}',
    amount_too_big: 'Maksymalna kwota zwrotu {{amount}}',
    payment_frozen: 'Zwrot już zgłoszony przez klienta. {{provider}} kontaktuje się z klientem w sprawie zwrotu',
  },
  buttons: {
    refund: 'Zwrot',
    cancel: 'Anuluj',
  },
  toasts: {
    refund_successful: 'Zwrot {{amount}} został pomyślnie zainicjowany!',
  },
};
